// Handle variant selection and gallery update
jQuery(document).ready(function($) {
  // Check if device is mobile - define this as a function so it can be called whenever needed
  function checkIfMobile() {
    return window.innerWidth < 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  
  // Initial check
  let isMobile = checkIfMobile();
  
  // Look for color swatches container
  const $colorSwatchesContainer = $('.color-swatches-container');
  
  if ($colorSwatchesContainer.length > 0) {
    // Listen for clicks on any elements inside the container
    $colorSwatchesContainer.on('click', function(event) {
      // Find the clicked swatch
      const $clickedSwatch = $(event.target).closest('.color-swatch, .swatch, [data-value]');
      
      if ($clickedSwatch.length > 0) {
        // Try to get the color value from various possible attributes
        const colorValue = $clickedSwatch.data('value') || 
                          $clickedSwatch.attr('data-value') || 
                          $clickedSwatch.val() || 
                          $clickedSwatch.text().trim();
        
        // Get the product handle from URL
        const urlMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
        const productHandle = urlMatch ? urlMatch[1] : null;
        
        if (productHandle) {
          // Fetch product data using jQuery ajax
          $.getJSON(`/products/${productHandle}.js`, function(product) {
            // Find matching variant for this color
            let matchingVariant = null;
            
            $.each(product.variants, function(i, variant) {
              // Check each option (1, 2, 3) to see if it matches the color
              if (variant.option1 === colorValue || 
                  variant.option2 === colorValue || 
                  variant.option3 === colorValue) {
                matchingVariant = variant;
                return false; // Break the loop
              }
            });
            
            if (matchingVariant && matchingVariant.featured_media) {
              const mediaId = matchingVariant.featured_media.id;
              
              // Re-check mobile status when processing the selection
              isMobile = checkIfMobile();
              
              if (isMobile) {
                // Mobile: Find and click the thumbnail with matching media ID
                const $thumbnails = $('.thumbnail-list__item');
                let $matchingThumbnail = null;
                
                // Look for thumbnail with matching data-custom-media-id
                $thumbnails.each(function() {
                  const thumbnailMediaId = $(this).attr('data-custom-media-id');
                  
                  if (thumbnailMediaId == mediaId) {
                    $matchingThumbnail = $(this);
                    return false; // Break the loop
                  }
                });
                
                // If not found by data-custom-media-id, try other selectors
                if (!$matchingThumbnail) {
                  $thumbnails.each(function() {
                    const $item = $(this);
                    const dataMediaId = $item.attr('data-media-id');
                    const dataImageId = $item.attr('data-image-id');
                    const mediaIdInButton = $item.find('[data-media-id="' + mediaId + '"], [data-target="' + mediaId + '"]').length > 0;
                    
                    if (dataMediaId == mediaId || dataImageId == mediaId || mediaIdInButton) {
                      $matchingThumbnail = $item;
                      return false;
                    }
                  });
                }
                
                // Click the thumbnail or its button
                if ($matchingThumbnail) {
                  const $button = $matchingThumbnail.find('button');
                  if ($button.length > 0) {
                    $button.trigger('click');
                  } else {
                    $matchingThumbnail.trigger('click');
                  }
                }
              } else {
                // Desktop: Find the matching .product__media-item with data-custom-media-id
                const $mediaItems = $('.product__media-item.grid__item');
                let $matchingItem = null;
                
                // Find the item with the matching media ID
                $mediaItems.each(function() {
                  const itemMediaId = $(this).attr('data-custom-media-id');
                  
                  if (itemMediaId == mediaId) {
                    $matchingItem = $(this);
                    return false; // Break the loop
                  }
                });
                
                if ($matchingItem) {
                  // Add is-active class to the matching item and remove from others
                  $mediaItems.removeClass('is-active');
                  $matchingItem.addClass('is-active');
                  
                  // Move the matching item to the first position in its parent (ul)
                  const $parent = $matchingItem.parent();
                  
                  if ($parent.length > 0) {
                    // Check if it's not already the first child
                    if (!$matchingItem.is(':first-child')) {
                      $parent.prepend($matchingItem);
                    }
                  }
                } else {
                  // Fallback: Try other data attributes if data-custom-media-id isn't found
                  $mediaItems.each(function() {
                    const $item = $(this);
                    const dataMediaId = $item.attr('data-media-id');
                    const dataImageId = $item.attr('data-image-id');
                    const mediaIdFromButton = $item.find('[data-media-id="' + mediaId + '"]').length > 0;
                    
                    if (dataMediaId == mediaId || dataImageId == mediaId || mediaIdFromButton) {
                      $matchingItem = $item;
                      return false; // Break the loop
                    }
                  });
                  
                  if ($matchingItem) {
                    // Apply the same actions as above
                    $mediaItems.removeClass('is-active');
                    $matchingItem.addClass('is-active');
                    
                    const $parent = $matchingItem.parent();
                    if ($parent.length > 0 && !$matchingItem.is(':first-child')) {
                      $parent.prepend($matchingItem);
                    }
                  }
                }
              }
            }
          }).fail(function(error) {
            // Silent fail
          });
        }
      }
    });
  } else {
    // Try alternative selectors for color options
    const $colorSelectors = $('.single-option-selector, [data-option-index="1"] select, input[name*="option-1"], .swatch-element');
    
    if ($colorSelectors.length > 0) {
      $colorSelectors.on('change', function() {
        const colorValue = $(this).val();
        
        // Get the product handle from URL
        const urlMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
        const productHandle = urlMatch ? urlMatch[1] : null;
        
        if (productHandle) {
          // Fetch product data
          $.getJSON(`/products/${productHandle}.js`, function(product) {
            // Find matching variant for this color
            let matchingVariant = null;
            
            $.each(product.variants, function(i, variant) {
              if (variant.option1 === colorValue || 
                  variant.option2 === colorValue || 
                  variant.option3 === colorValue) {
                matchingVariant = variant;
                return false; // Break the loop
              }
            });
            
            if (matchingVariant && matchingVariant.featured_media) {
              const mediaId = matchingVariant.featured_media.id;
              
              // Re-check mobile status when processing the selection
              isMobile = checkIfMobile();
              
              if (isMobile) {
                // Mobile: Find and click the thumbnail
                const $thumbnails = $('.thumbnail-list__item');
                let $matchingThumbnail = null;
                
                // Try to find thumbnail with matching data-custom-media-id
                $thumbnails.each(function() {
                  if ($(this).attr('data-custom-media-id') == mediaId) {
                    $matchingThumbnail = $(this);
                    return false;
                  }
                });
                
                // If not found, try alternative attributes
                if (!$matchingThumbnail) {
                  $thumbnails.each(function() {
                    const $item = $(this);
                    const hasMediaId = $item.attr('data-media-id') == mediaId || 
                                      $item.find('[data-media-id="' + mediaId + '"], [data-target="' + mediaId + '"]').length > 0;
                    
                    if (hasMediaId) {
                      $matchingThumbnail = $item;
                      return false;
                    }
                  });
                }
                
                // Click the thumbnail or its button
                if ($matchingThumbnail) {
                  const $button = $matchingThumbnail.find('button');
                  if ($button.length > 0) {
                    $button.trigger('click');
                  } else {
                    $matchingThumbnail.trigger('click');
                  }
                }
              } else {
                // Desktop: Find the matching .product__media-item
                const $mediaItems = $('.product__media-item.grid__item');
                let $matchingItem = null;
                
                // Try to find item with matching data-custom-media-id
                $mediaItems.each(function() {
                  if ($(this).attr('data-custom-media-id') == mediaId) {
                    $matchingItem = $(this);
                    return false;
                  }
                });
                
                // If not found, try alternative attributes
                if (!$matchingItem) {
                  $mediaItems.each(function() {
                    const $item = $(this);
                    if ($item.attr('data-media-id') == mediaId || 
                        $item.attr('data-image-id') == mediaId || 
                        $item.find('[data-media-id="' + mediaId + '"]').length > 0) {
                      $matchingItem = $item;
                      return false;
                    }
                  });
                }
                
                if ($matchingItem) {
                  // Add is-active class and remove from others
                  $mediaItems.removeClass('is-active');
                  $matchingItem.addClass('is-active');
                  
                  // Move to first position in parent
                  const $parent = $matchingItem.parent();
                  if ($parent.length > 0 && !$matchingItem.is(':first-child')) {
                    $parent.prepend($matchingItem);
                  }
                }
              }
            }
          });
        }
      });
    }
  }
  
  // Also handle window resize to update behavior when switching between mobile and desktop
  let lastIsMobile = isMobile;
  $(window).on('resize', function() {
    const currentIsMobile = checkIfMobile();
    
    // Only update if mobile status changed
    if (currentIsMobile !== lastIsMobile) {
      lastIsMobile = currentIsMobile;
      // The different behavior will be applied on the next color selection
    }
  });
}); 